<template>
  <div>
    <button
      class="btn btn-icon btn-light-success mr-1"
      type="button"
      v-b-tooltip.noninteractive.hover.left
      title="Configurações"
      @click="abrir()"
    >
      <i class="fa-solid fa-cog"></i>
    </button>

    <b-modal
      ref="mdlConfiguracoesWhatsappOficial"
      title="Whatsapp Oficial"
      @hidden="limpar"
      @ok="salvar"
      @shown="validacao"
      ok-variant="success"
      ok-title="Salvar"
      cancel-title="Cancelar"
    >
      <b-form ref="frmWhatsapp">
        <b-form-group>
          <label>Recado:</label>
          <b-form-input
            name="about"
            v-model="frmWhatsapp.profile.about"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

import { mapGetters } from "vuex";

export default {
  props: {
    conta: Object
  },

  data() {
    return {
      frmWhatsapp: {
        idConta: null,
        profile: {
          about: "",
          messaging_product: "whatsapp"
        }
      }
    };
  },

  computed: {
    ...mapGetters(["validatorErrors"])
  },

  methods: {
    limpar() {
      this.frmWhatsapp.idConta = null;
      this.frmWhatsapp.profile.about = "";
      this.frmWhatsapp.profile.messaging_product = "whatsapp";
    },

    abrir() {
      this.limpar();

      this.frmWhatsapp.idConta = this.conta.id;

      ApiService.post("conta/obter-whatsapp-profile", {
        conta_id: this.conta.id
      }).then((response) => {
        const profile = response.data.data;

        this.frmWhatsapp.profile.about = profile?.about;

        this.$refs["mdlConfiguracoesWhatsappOficial"].show();
      });
    },

    validacao() {
      const frmWhatsapp = this.$refs["frmWhatsapp"];

      this.fv = formValidation(frmWhatsapp, {
        fields: {
          recado: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      });
    },

    salvar() {
      this.fv.validate().then((status) => {
        if (status == "Valid") {
          ApiService.post("conta/atualizar-whatsapp-profile", {
            ...this.frmWhatsapp,
            conta_id: this.conta.id
          })
            .then(() => {
              this.$emit("aba-alterada", false);

              Swal.fire({
                title: "MENSAGEM",
                text: "Atualizado com sucesso!",
                icon: "success",
                heightAuto: false
              });
            })
            .catch(() => {
              for (const error in this.validatorErrors) {
                this.fv
                  .updateValidatorOption(
                    error,
                    "blank",
                    "message",
                    this.validatorErrors[error]
                  )
                  .updateFieldStatus(error, "Invalid", "blank");
              }
            });
        }
      });
    }
  }
};
</script>
